<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
  <div class="d-flex flex-wrap" *ngIf="token">
    <div class="two-card common-padding add-money shadow">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
      &nbsp;
      <h2 class="heading">Edit Bank Transfer Beneficiary </h2>
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="row no-gutters">
            <div class="col-12 form-padding">
              <form class="example-form" (ngSubmit)="EditIdbanktransferbeneficiary(EditIdbanktransferbeneficiaryForm.value)" [formGroup]="EditIdbanktransferbeneficiaryForm">
                <div class="row no-gutters">
                  <div class="col-md-12">
                    <div class="row no-gutters">
                      <div class="col-6">
                        Country Name : <label><b>{{countrytxt}}</b></label>
                      </div>
                      <div class="col-6">
                        Bank Name : <label><b>{{bank_name}}</b></label>
                        <!--<mat-form-field>
                          <mat-label>Select Bank Name</mat-label>
                          <mat-select formControlName="channel_Code" required [disabled]="true">
                            <mat-form-field>
                              <input matInput [formControl]="BankListFilterCtrl" placeholder="Search Bank" />
                            </mat-form-field>
                            <mat-option [value]="d?.entryId" *ngFor="let d of filterBankList(); let i=index">

                              {{d?.bankName}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.channel_Code?.errors?.required">
                            Bank Name is required
                          </mat-error>
                        </mat-form-field>-->
                      </div>
                      <div class="col-12" *ngIf="countrytxt == 'India'">
                        <mat-form-field>

                          <input matInput placeholder="Enter IFS Code" formControlName="beneficiary_bank_code" minlength="5" maxlength="20" />

                          <mat-error *ngIf="f.beneficiary_bank_code?.errors?.maxlength">
                            Maximum Length IFS Code is 20
                          </mat-error>

                          <mat-error *ngIf="f.beneficiary_bank_code?.errors?.minlength">
                            Minimum Length IFS Code is 5
                          </mat-error>

                        </mat-form-field>
                      </div>
                      <div class="col-6">
                        <mat-form-field class="example-full-width input-tel">
                          <input matInput placeholder="Beneficiary First Name" formControlName="beneficiary_fname" maxlength="50" required />
                          <mat-error *ngIf="submitted && f.beneficiary_fname?.errors?.required">
                            Enter Beneficiary First Name
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_fname?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-6">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary Middle Name(optional)" formControlName="beneficiary_mname" maxlength="50" />

                          <mat-error *ngIf="submitted && f.beneficiary_mname?.errors?.required">
                            Enter Beneficiary Middle Name
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_mname?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>
                        </mat-form-field>
                      </div>


                      <div class="col-6">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary Last Name" formControlName="beneficiary_lname" maxlength="50" required />

                          <mat-error *ngIf="submitted && f.beneficiary_lname?.errors?.required">
                            Enter Beneficiary Last Name
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_lname?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-6">
                        <mat-form-field class="example-full-width input-tel">
                          <input type="tel" matInput placeholder="Enter Bank Account Number" formControlName="beneficiary_account_no" Numberonly maxlength="50" required />
                          <mat-error *ngIf="submitted && f.beneficiary_account_no?.errors?.required">
                            Bank Account Number is required
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_account_no?.errors?.maxlength">
                            Maximum Length Mobile No. is 50
                          </mat-error>

                        </mat-form-field>
                      </div>
                      <div class="col-6">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary Address" formControlName="beneficiary_address" maxlength="150" required />

                          <mat-error *ngIf="submitted && f.beneficiary_address?.errors?.required">
                            Enter Beneficiary Address
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_address?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>

                        </mat-form-field>
                      </div>


                      <div class="col-6">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary State" formControlName="beneficiary_state" maxlength="50" required/>

                          <mat-error *ngIf="submitted && f.beneficiary_state?.errors?.required">
                            Enter Beneficiary State
                          </mat-error>

                        </mat-form-field>
                      </div>

                      <div class="col-6">
                        <mat-form-field class="example-full-width input-tel">
                          <input type="tel" matInput placeholder="Beneficiary Mobile No. with Country Code"
                                 formControlName="beneficiary_phone" Numberonly minlength="1" maxlength="20" required />
                          <mat-error *ngIf="submitted && f.beneficiary_phone?.errors?.required">
                            Beneficiary Mobile No. with Country Code is required
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_phone?.errors?.maxlength">
                            Maximum Length Beneficiary Mobile No. with Country Code is 20
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_phone?.errors?.minlength">
                            Minimum Length Beneficiary Mobile No. with Country Code is 1
                          </mat-error>
                        </mat-form-field>
                        <p style="color: red;">Note : Kindly enter phone number with country code</p>

                      </div>
                      <div class="col-6">
                        <mat-form-field>
                          <input matInput type="email" placeholder="Beneficiary Email" formControlName="beneficiary_email" maxlength="100" required />
                          <mat-error *ngIf="submitted && f.beneficiary_email.errors">
                            Enter Valid Email
                          </mat-error>
                        </mat-form-field>
                      </div>


                    </div>
                  </div>


                  <div class="col-12">
                    <button class="primary-btn" type="submit"> UPDATE</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12 mt-4">
          <div class="pay-detail text-center">
            <div class="icon_wrap">
              <i class="icon-payment_secure"></i>
            </div>
            <span class="ng-binding">Your payment details are secured</span>
          </div>
        </div>
      </div>
    </div>


  </div>

</fieldset>
